import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@services/authentication/authentication.service';

@Component({
  standalone: true,
  selector: 'app-session',
  imports: [],
  template: `<div class="content-pane">Redirecting...</div>`,
})
export class SessionComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly authService: AuthenticationService,
    private readonly router: Router,
  ) {}

  // Use a lifecycle hook here because it guarantees that the user signal is updated before navigating back to the previous url:
  ngOnInit(): void {
    (async () => {
      try {
        const target = await this.authService.completeLogin(this.route.snapshot);
        await this.router.navigateByUrl(target);
      } catch (err) {
        console.error('Session failed', err);
      }
    })();
  }
}
